import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: a = 16, useVw: n, useRem: c, color: e, withColor: o, removeClassName: l, disableSSR: p, style: i, ...f }) => {
  const m = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ t.createElement(x, { disableSSR: p }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-caifuguanli", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: m, fill: "none", ...f }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: l ? "" : "32px-è´¢å¯ç®¡ç"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: l ? "" : "normal",
        d: "M16 4.9C9.87 4.9 4.9 9.87 4.9 16c0 1.193.188 2.34.535 3.416.02.062.058.097.12.115a.3.3 0 0 0 .255-.053l4.59-3.287a.9.9 0 0 1 1.2.14l2.659 3.038 6.243-5.095-2.704-.144a.9.9 0 0 1 .096-1.798l5.03.27a.9.9 0 0 1 .52 1.595l-8.721 7.116a.9.9 0 0 1-1.246-.105l-2.694-3.078-3.925 2.812c-1.054.755-2.684.424-3.136-.973A12.892 12.892 0 0 1 3.1 16C3.1 8.876 8.876 3.1 16 3.1c7.125 0 12.9 5.776 12.9 12.9 0 7.125-5.775 12.9-12.9 12.9-2.556 0-4.941-.744-6.947-2.028a.9.9 0 1 1 .97-1.516A11.044 11.044 0 0 0 16 27.1c6.13 0 11.1-4.97 11.1-11.1S22.13 4.9 16 4.9Z",
        fill: o ? r(e, 0, "#262933") : "#262933",
        datafollowfill: o ? r(e, 0, "#262933") : "#262933"
      }
    )
  )));
}, k = g;
export {
  k as default
};
